import React, { useMemo } from 'react';
import {
  BarChart,
  Bar,
  CartesianGrid,
  Tooltip,
  XAxis,
  YAxis,
  Legend,
  ResponsiveContainer,
} from 'recharts';
import { useQuery } from '@tanstack/react-query';
import NoDataAvailable from './NoDataAvailable';
import { fetchAutomationProgressBySprint } from '../../../../../modules/dashboard';
import ChartTitle from '../../../../elements/ChartTitle';

const GRAPH_TITLE = 'TCs Automation Progress By Week';

const daysName = [
  { name: 'Sun', color: '#2E2E2E' },
  { name: 'Mon', color: '#D32F2F' },
  { name: 'Tue', color: '#F57C00' },
  { name: 'Wed', color: '#FBC02D' },
  { name: 'Thu', color: '#388E3C' },
  { name: 'Fri', color: '#1976D2' },
  { name: 'Sat', color: '#7B1FA2' },
];

const getWeekData = (weekData = []) => {
  return weekData.reduce((acc, { day, automated_count }) => {
    acc[`${day}`] = automated_count;
    return acc;
  }, {});
};

const AutomationProgressByWeek = ({ projectId }) => {
  const {
    data = [],
    isLoading,
    isError,
  } = useQuery({
    queryKey: ['automationProgressBySprint', projectId],
    queryFn: () => fetchAutomationProgressBySprint(projectId),
    select: (res) => res?.data || [],
    enabled: !!projectId,
  });

  const formattedData = useMemo(() => {
    return data?.map((item) => ({
      week_range: item.week_range,
      ...getWeekData(item.week_data),
    }));
  }, [data]);

  return (
    <div className="chart-div">
      <ChartTitle title={GRAPH_TITLE} />
      <p className="text-muted" style={{ fontSize: '12px' }}>
        (Showing results for last 4 weeks)
      </p>
      {isLoading || isError || data.length === 0 ? (
        <NoDataAvailable />
      ) : (
        <ResponsiveContainer width="100%" height={300}>
          <BarChart data={formattedData} barSize={25} margin={{ top: 5, right: 30, left: 20, bottom: 5 }}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis
              dataKey="week_range"
              label={{ value: 'Weeks', position: 'insideBottom', offset: -10 }}
              tick={{ fontSize: 12 }}
            />
            <YAxis allowDecimals={false} />
            <Tooltip />
            <Legend wrapperStyle={{ padding: 10 }} />
            {daysName.map((day) => (
              <Bar
                key={day.name}
                dataKey={`${day.name}`}
                fill={day.color}
                stackId="a"
              />
            ))}
          </BarChart>
        </ResponsiveContainer>
      )}
    </div>
  );
};

export default AutomationProgressByWeek;
